import {ChangeDetectionStrategy, Component} from '@angular/core';
import { ConfigService } from '../../../services/config.service';
import { AuthService } from '../../../services/auth.service';
import {ProfileService} from '../../../services/profile.service';
import {ModalService} from '../../../services/modal.service';

@Component({
    selector: 'app-user-menu',
    templateUrl: './user-menu.component.html',
    styleUrls: ['./user-menu.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})

export class UserMenuComponent {

    constructor(private config: ConfigService,
                private auth: AuthService,
                private modalService: ModalService,
                private profileService: ProfileService) {}

    public logoutWarning() {
        this.profileService.showLogout();
    }

    get canShowTransaction(): boolean {
        return false;
        // return this.auth.canSeeTransactions;
    }

    get canShowPaymentPage(): boolean {
        return this.auth.canSeePaymentMethods && this.config.showBillingInfo;
    }

    get canShowBudgets(): boolean {
        return false;
        // return this.auth.canSeeBudgets;
    }

    get canShowAutoshipPage(): boolean {
        return  false;
        // return this.auth.canAutoship;
    }

    get canSeeOrders(): boolean {
        return this.auth.canSeeOrders;
    }

    get canSeeAddresses(): boolean {
        return this.auth.canSeeAddresses;
    }

    get canSeeDistributionGroups(): boolean {
        return this.auth.hasDistributionGroupRole;
    }

    handleOrderOnBehalfOf() {
        this.modalService.showDistributionGroupModal().subscribe();
    }
}
